// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"fa2f4a5e","363":"f5cfd208","414":"a07f5750","787":"953d6859","888":"c2568e81"}[chunkId] + ".chunk.js";
};